import { colors } from 'style'
import styled from 'styled-components'

export const PromptCatalogContainer = styled.div`
  height: 100%;

  .prompts {
    height: 100%;

    .row {
      height: 100%;

      .col {
        height: 100%;
      }
    }

    .prompts-wrapper {
      height: 100%;
      display: flex;
      flex-direction: ${(props) => (props.isMobile ? 'column' : 'row')};
      justify-content: space-between;
      align-items: flex-start;

      .prompts-part {
        height: 100%;
        display: flex;
        flex-direction: column;
        flex: 1;
        position: relative;
        .custom-question-group {
          &.story {
            overflow-y: scroll;
            background: white;
            border-radius: 15px;
          }

          &.active {
            border-right: 40px solid #4e9e69;
            border-bottom-right-radius: 15px;
            border-top-right-radius: 15px;
            z-index: 9;
          }

          &.textarea {
            max-height: 180px;
            min-height: 180px;
            margin-bottom: 20px;
          }
        }
        .chosen-story-group {
          height: 100%;
          overflow-y: scroll;
          padding: 20px;
          background: white;
          border-radius: 15px;

          .prompt-items {
            margin-top: 0px !important;

            .prompt-item {
              padding: 5px 20px 5px 0px !important;
            }

            span {
              margin-left: 0rem !important;
            }
          }
        }
        .prompt-handler {
          position: absolute;
          cursor: pointer;
          background: ${(props) => (props.isMobile ? 'white' : 'transparent')};
          width: ${(props) => (props.isMobile ? '30px' : 'unset')};
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 2px;
          top: 50% !important;
          color: white !important;
          background: transparent !important;
        }
        .prompt-items {
          background-color: white;
          .prompt-item-border-top {
            border-top: 1px solid #f4f3f3;
          }
          .prompt-item {
            padding: 5px 20px 5px 10px;
            cursor: pointer;
            &.selected {
              .prompt-item {
                background-color: #bfbfbf;
              }
              .prompt-item-tag {
                background-color: #bfbfbf;
                padding-bottom: 5px;
              }
              // background-color: #bfbfbf;
            }
          }
          .sent {
            font-style: italic;
            color: ${colors.dark4};
            cursor: not-allowed;
          }

          span {
            margin-left: 0.5rem !important;
          }
        }
        .prompt-items::-webkit-scrollbar {
          // display: none;
        }
        &.prompts-left {
          .prompt-handler {
            right: ${(props) => (props.isMobile ? '0' : '5px')};
            top: ${(props) => (props.isMobile ? '0' : '50%')};

            svg {
              color: white;
            }
          }
        }
        &.prompts-right {
          &.active {
            border-left: 40px solid #4c4c4c;
            border-top-left-radius: 15px;
            border-bottom-left-radius: 15px;
          }
          .prompt-items {
            margin-top: 40px;
          }
          .prompt-handler {
            left: -35px;
            top: ${(props) => (props.isMobile ? '0' : '50%')};

            svg {
              color: white;
            }
          }
        }
        .prompt-add-wrapper {
          position: relative;
          // margin-top: 20px;
          width: 50%;
          display: flex;
          flex-direction: ${(props) => (props.isMobile ? 'column' : 'row')};
          align-items: center;
          .prompt-add-input {
            flex: 1;
          }
          .icon-add-wrapper {
            position: absolute;
            width: 20px;
            right: -17px;
            cursor: pointer;
            top: 10px;

            svg {
              color: white;
            }
          }
          .btn-add {
            margin-top: 8px;
            width: 50%;
            height: 32px;
          }
        }
      }
      .action-disable {
        color: ${colors.grayLight};
        cursor: not-allowed !important;
        display: none;
      }
    }
  }

  .tab-content {
    height: calc(100% - 50px);

    .tab-pane {
      height: 100%;
      .prompts-part {
        height: 100%;
      }
    }

    margin-top: 8px;
    .custom-question-group {
      .mobile-story-group {
        background-color: white;
        border-radius: 15px;

        .prompt-handler {
          top: 60% !important;
          color: white !important;
          background: transparent !important;
          margin-right: 5px !important;
        }

        .selectbox-group {
          width: 286px !important;
          margin: 20px;

          &.active {
            width: 245px !important;
          }
        }
      }

      .active {
        margin-right: 0 !important;
      }

      &.textarea {
        max-height: 180px;
        min-height: 180px;
        margin-bottom: 20px;
      }
    }

    .chosen-story-group {
      .prompt-handler {
        margin-right: 291px !important;
        top: 50% !important;
        color: white !important;
        background: transparent !important;
      }
    }
  }
`
